export const ADD_COUNTER = 'ADD_COUNTER'
export const ADD_TO_CART = 'ADD_TO_CART'



// WEBPACK FOOTER //
// ./src/store/mutationTypes.js